import { useNavigation } from '@/app/hooks'
import { Resource } from '@/authenticated/components/ResourceSelectionGallery/types'
import useMultiProgramFlowControl from '@/hooks/useMultiProgramFlowControl'

/**
 * The gallery actions are the buttons in the gallery that allow the user to
 * perform actions other than device selection, e.g. add a new device.
 *
 * @returns An array of resources that define the gallery actions.
 */
export function useGalleryActions(): Resource[] {
  const { clearFlow } = useMultiProgramFlowControl()
  const navigation = useNavigation()

  const connectDeviceActionResource = {
    name: 'Connect Device',
    id: `resource-gallery-connect-device`,
    details: 'Connect Device',
    action: () => {
      // Clear the multi-program /connect-device flow here since we know that is not how
      // the user got to /connect-device
      clearFlow()
      navigation.push('/connect-device')
    },
    selected: false,
    variant: 'action' as const,
  }

  return [connectDeviceActionResource]
}
